import { faCircleDollar } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FunctionComponent } from 'react';
import styles from './ClientOverviewTransactionsEmpty.module.scss';

export const ClientOverviewTransactionsEmpty: FunctionComponent = () => (
    <div className={styles.emptyState}>
        <div className={styles.iconCircle}>
            <FontAwesomeIcon
                icon={faCircleDollar}
                className={styles.icon}
            />
        </div>
        <p className={styles.emptyTitle}>No Transactions Yet</p>
        <p className={styles.emptyDescription}>This client has no registered transactions.</p>
    </div>
);

export default ClientOverviewTransactionsEmpty;
